export default {
    FILE: 1,
    TXT: 2,
    WORD: 3,
    EXCEL: 4,
    IMAGE: 5,
    PDF: 6,
    VISIO: 7
};
